import React, {useContext} from "react";
import Meals from "./Meals";
import CategoriesScroll from "./CategoriesScroll";
import BannerRenderer from "../common/BannerRenderer";
import GlobalContext from "../../context/GlobalContext";


const MenuWrapper = (props) => {
    const context = useContext(GlobalContext);

  return (
    <div>
      <CategoriesScroll />
      <Meals />
      {context.banner && <BannerRenderer image={context.configuration?.restaurantDetails?.banner} link={context.configuration?.restaurantDetails?.bannerLink} linkEnabled={context.configuration?.restaurantDetails?.bannerLinkEnabled} />}
    </div>
  );
};

export default MenuWrapper;
